import { type FC, type ReactNode } from "react";

import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeadlineIcon: FC<{
  icon: IconDefinition;
}> = ({ icon }) => (
  <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-linear-to-br from-violet-500 to-violet-600 text-white">
    <FontAwesomeIcon icon={icon} className="size-5" />
  </div>
);

const HeadlineTitle: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="flex items-center gap-2 text-lg font-semibold text-slate-800">
    {children}
  </div>
);

const HeadlineSubtitle: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="text-sm font-medium text-slate-600">{children}</div>
);

const HeadlineContent: FC<{
  children: ReactNode;
}> = ({ children }) => <div className="flex flex-wrap gap-4">{children}</div>;

const HeadlineContainer: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="flex flex-wrap items-center justify-between gap-y-3 border-b border-slate-200 pb-4">
    {children}
  </div>
);

export const Headline: FC<{
  avatar?: ReactNode;
  icon?: IconDefinition;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
}> = ({ avatar, icon, title, subtitle, children }) => (
  <HeadlineContainer>
    <div className="flex items-center gap-4">
      {avatar}
      {icon && <HeadlineIcon icon={icon} />}
      {(title || subtitle) && (
        <div>
          {title && <HeadlineTitle>{title}</HeadlineTitle>}
          {subtitle && <HeadlineSubtitle>{subtitle}</HeadlineSubtitle>}
        </div>
      )}
    </div>
    {children && <HeadlineContent>{children}</HeadlineContent>}
  </HeadlineContainer>
);
